import { Popover } from 'antd';
import { HiOutlineExclamationCircle } from 'react-icons/hi2';

export interface BadgeProps {
  title: string;
  description: string;
  button: string;
}

export const TradeIdeasBadge = ({ badge }: { badge: BadgeProps | null }) => {
  if (!badge) return null;

  const badgeContent = (
    <div className="flex max-w-[300px] flex-col rounded-lg bg-bzblue-900 p-4 text-white">
      <div className="text-base font-bold md:text-lg">{badge.title}</div>
      <p className="mb-4 mt-2 text-sm leading-5 text-bzblue-300">{badge.description}</p>
      <a
        href="https://www.benzinga.com/pro/pricing?utm_source=portfolio_trade_ideas"
        target="_blank"
        rel="noopener noreferrer"
        className="w-full rounded-md bg-white px-4 py-2 text-center text-sm font-bold text-bzblue-900 hover:bg-bzblue-100"
      >
        {badge.button}
      </a>
    </div>
  );

  return (
    <Popover rootClassName="trade-ideas-popover" content={badgeContent} title="" arrow={false}>
      <button
        type="button"
        className="inline-flex items-center gap-1 rounded-md border border-bzblue-200 bg-bzblue-100 px-2 py-1 text-[10px] font-bold uppercase tracking-wide text-bzblue-800 hover:bg-bzblue-200"
      >
        <HiOutlineExclamationCircle className="size-3.5" />
        Trade Ideas
      </button>
    </Popover>
  );
};
